import React, {useState, useEffect} from "react";
import {connect} from "react-redux";
import axios from "axios";
import {serverLink} from "../../resources/url";
import {Link, useNavigate} from "react-router-dom";
import {
    setApplicationDetails,
    setApplicationRequirementDetails,
    setGeneralDetails
} from "../../actions/actions";
import Header from "../common/header/header";
import PgSidebar from "../common/sidebar/pgsidebar";
function PostgraduateDashboard(props) {
    const navigate = useNavigate();
    const [userData] = useState(props.applicationLogin);
    const [IsLoading, setIsLoading] = useState(false)
    const [requirementList, setrequirementList] = useState([]);
    const [applicationRequirement, setApplicationRequirement] = useState([]);
    const [applicationDetail, setApplicationDetail] = useState({
        oLevel: [],
        jamb: [],
        post_secondary: [],
        guardian: [],
        document: [],
    });

    const getUGApplicationRequirementList = async () => {
        await axios
            .get(`${serverLink}application/pg/requirements/`)
            .then((response) => {
                props.setApplicationRequirement(response.data.data);
            })
            .catch((error) => {
                console.log("NETWORK ERROR", error);
            });
    };

    useEffect(() => {
        getUGApplicationRequirementList();
    }, []);

    useEffect(() => {
        async function applicationRequirementList() {
            axios
                .get(`${serverLink}application/documents/uploads`)
                .then((response) => {
                    setrequirementList(response.data);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
        applicationRequirementList();
    }, []);

    useEffect(() => {
        async function allApplicationData() {
            axios
                .get(
                    `${serverLink}application/pg/application/data/${props.applicationData.EntryID}`
                )
                .then((response) => {
                    setApplicationDetail(response.data);
                    props.setOnGeneralDetails(response.data);
                    setIsLoading(false);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
        allApplicationData();
    }, []);

    useEffect(() => {
        if (props.applicationLogin.length === 0)
            navigate("/login");
    }, [props.applicationLogin]);

    return (
        IsLoading ?
            <>Loading</>
            :
            <>
                <div className="main-wrapper">
                    <Header/>
                    <PgSidebar/>
                    <div className="page-wrapper">
                        <div className="content">

                            <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                                <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                                    <div className="my-auto mb-2">
                                        <h3 className="page-title mb-1">Welcome, {`${userData.FirstName} ${userData.MiddleName} ${userData.Surname}`
                                        }</h3>
                                        <nav>
                                            <ol className="breadcrumb mb-0">
                                                <li className="breadcrumb-item">
                                                    <a href="">Dashboard</a>
                                                </li>
                                                <li className="breadcrumb-item active" aria-current="page">Dashboard</li>
                                            </ol>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 d-flex">
                                    <div className="row flex-fill">
                                        <div className="col-md-6 d-flex">
                                            <div className="flex-fill">
                                                <div className="card flex-fill">
                                                    <div className="card-header d-flex align-items-center justify-content-between">
                                                        <h4 className="card-title">Instruction</h4>
                                                    </div>
                                                    <div className="card-body d-flex justify-content-center align-items-center">
                                                        <div className="col-lg-12">
                                                            <p>
                                                                <strong>
                                                                    Note: You can start filling the application by clicking
                                                                    {"  "}
                                                                </strong>
                                                                on{"  "}
                                                                <span style={{ color: "green" }}>
                                            Start Application
                                        </span>{" "}
                                                                button below
                                                            </p>
                                                            <p>
                                                                You can re-enter and complete your application(s) at any
                                                                time convenient to you. Please fill in the application
                                                                details using guidance on the screens, you will see ‘next’
                                                                and ‘previous’ buttons to help you navigate your way around.
                                                            </p>
                                                            <h4>Required Document to Upload</h4>
                                                <p></p>
                                                <b>
                                                            <ul>
                                                                {requirementList.map((requirement, index) => (
                                                                    <li key={index}>{requirement.DocumentName}</li>
                                                                ))}
                                                            </ul>
                                                            </b>
                                                            <br/>
                                                            <p>
                                                                Before you submit your application you can view your
                                                                application in the application summary page.
                                                            </p>
                                                            <p>
                                                                Before you submit your application you will be asked to
                                                                confirm by declaration that the data you are submitting is
                                                                correct.
                                                            </p>

                                                            <div className="d-flex flex-column flex-sm-row gap-3">
                                                                <Link to={"/application"} className="btn btn-dark w-100">
                                                                    Go Back
                                                                </Link>
                                                                <Link to={"/postgraduate/personal-information"} className="btn btn-primary w-100">
                                                                    Start Application
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/*row*/}
                                    </div>
                                </div>
                            </div>
                            {/*<Footer/>*/}
                        </div>
                    </div>
                </div>
            </>
    );
}

const mapStateToProps = (state) => {
    return {
        applicationLogin: state.loginDetails,
        applicationData: state.applicationDetails,
        applicant_data: state.generalDetails,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        setOnApplicationDetails: (p) => {
            dispatch(setApplicationDetails(p));
        },
        setOnGeneralDetails: (p) => {
            dispatch(setGeneralDetails(p));
        },
        setApplicationRequirement: (p) => {
            dispatch(setApplicationRequirementDetails(p));
        },
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(PostgraduateDashboard);
